export default __webpack_public_path__ + "static/media/title_zh_cn_sp.d806f8c3.png";